/*
 * @fileOverView Dropdown component definition
 */

import Vue from 'vue';
import { TweenLite } from 'gsap';
import { KeyCodes, Events } from 'utils/Constants';

/**
 * Classes added and removed during dropdown manipulation.
 */
const CLASSES = {
  'IGNORE_VIEWPORT': 'js-dropdown_ignoreViewport',
  'OPEN_ABOVE': 'js-dropdown-list_openAbove'
}

/**
 * [Drodown Vue]
 * @type {class}
 */
Vue.component('filter-dropdown-vue', {
  props: [
    'optionCount',
    'parentIndex',
    'parentSelected'
  ],

  data: function() {
    return {
      isExpanded: false,
      activeIndex: 0,
      selected: '',
      selectedIndex: '',
      maxIndex: this.optionCount - 1
    }
  },

  watch: {
    activeIndex: function(val) {
      if (this.activeIndex > this.maxIndex) {
        this.activeIndex = 0;
      }
      else if (this.activeIndex < 0) {
        this.activeIndex = this.maxIndex;
      }
      this.focusItem(this.activeIndex);
    },

    /**
     * React to an index change by a parent element, such as tabs.
     * @param {Integer} val
     */
    parentIndex: function(val) {
      if (this.$refs[val]) {
        this.selectItem(val);
      }
    },

    /**
     * React to an change by a parent element that is unaware of its index, such as a slider range.
     * @param {String} value
     */
    parentSelected: function(value) {
      this.set(value);
    },

    selected: function() {
      const $input = $(this.$refs.input);
      const $form = $input.closest('form');

      if ($form && $form.validate()) {
        this.$nextTick(() => {
          $input.valid();
        })
      }

      // Emit an event for parents that need to react, such as tabs.
      this.$emit('dropdown-changed', this.selectedIndex, this.selected, this.$el);
    }
  },

  mounted() {
    //sort filter js
    const relBtn = document.querySelector('.relevance-data');
    const titleBtn = document.querySelector('.dropdown-list-title');
    const titleDiv = document.querySelector('.radio-div-title');
    const yearBtn = document.querySelector('.dropdown-list-year');
    const yearDiv = document.querySelector('.radio-div-year');
    const activeListItem = document.querySelector('.active-list-item');
    const dropdownList = document.querySelector('.dropdown-list');
    const dropdownItems = document.querySelectorAll('.sort-list-options');
    const listItems = dropdownList.querySelectorAll('li');
    const firstSvg = document.querySelector('#first-svg');
    var svgElement = activeListItem.querySelector('svg');

    // Event listener for hiding divs on relevance button click
    relBtn.addEventListener('click', () => {
      yearDiv.classList.remove('show-year-div');
      titleDiv.classList.remove('show-title-div');
    });

    // Event listener for title button click
    titleBtn.addEventListener('click', () => {
      titleDiv.classList.toggle('show-title-div');
      if (yearDiv.classList.contains('show-year-div')) {
        yearDiv.classList.remove('show-year-div');
      }
      this.isExpanded = true;
    });

    // Event listener for year button click
    yearBtn.addEventListener('click', () => {
      yearDiv.classList.toggle('show-year-div');
      if (titleDiv.classList.contains('show-title-div')) {
        titleDiv.classList.remove('show-title-div');
      }
      this.isExpanded = true;
    });

    //Event listener for dropdown items
    dropdownItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        const clickedContent = item.querySelector('span').textContent;
        activeListItem.querySelector('span').textContent = clickedContent;
        dropdownItems.forEach((item) => {
          item.querySelector('span').classList.remove('selected-text');
        });
        item.querySelector('span').classList.add('selected-text');
      });
    });

    //Event listener for list items within the dropdown
    listItems.forEach((item, index) => {
      sessionStorage.setItem('key', 'Sort By');
      item.addEventListener('click', (event) => {
        activeListItem.className = 'active-list-item';
        if (item.classList.contains('rel-li')) {
          activeListItem.classList.add('relevance');
          sessionStorage.setItem('key', item.querySelector('span').textContent);
          firstSvg.style.display = 'none';
        }
        if ((item.classList.contains('year-li')) || (item.classList.contains('title-li'))) {
          const radioButtons = item.querySelectorAll('input[type=radio]');
          let isChecked;
          let selectedRadio;
          radioButtons.forEach((radio) => {
            if (radio.checked) {
              isChecked = 1;
              selectedRadio = radio;
            }
            if (radio.contains(event.target)) {
              this.isExpanded = false;
            }
          });
          if (isChecked) {

            activeListItem.classList.add(selectedRadio.value);
            firstSvg.style.display = 'none';
            const clickedContent = item.querySelector('span').textContent;
            activeListItem.querySelector('span').textContent = clickedContent;
            activeListItem.setAttribute('data-active-sort', clickedContent);
            activeListItem.setAttribute('data-active-order', selectedRadio.value);
          }
          else {
            let activesort = activeListItem.getAttribute('data-active-sort');
            let activeorder = activeListItem.getAttribute('data-active-order');
            activeListItem.querySelector('span').textContent = activesort;
            activeListItem.classList.add(activeorder);
            if (activesort === 'Sort by') {
              firstSvg.style.display = 'block'
            }
          }
          const filterSvg = {
            'az': `<path d="M2.46127 9.5H0.310556L3.58762 0.0071762H6.17404L9.44647 9.5H7.29575L4.91791 2.17643H4.84375L2.46127 9.5ZM2.32685 5.76869H7.407V7.33538H2.32685V5.76869ZM15.1561 3.97024V5.53693H10.8268V3.97024H15.1561ZM16.942 9.5V8.30876L21.6791 1.66193H16.9327V0.0071762H24.2007V1.19841L19.4589 7.84524H24.2099V9.5H16.942Z"/>`,
            'za': `<path d="M0.723086 9.5V8.30876L5.46023 1.66193H0.713816V0.0071762H7.98176V1.19841L3.23998 7.84524H7.99103V9.5H0.723086ZM14.0981 3.97024V5.53693H9.76885V3.97024H14.0981ZM17.6222 9.5H15.4715L18.7486 0.0071762H21.335L24.6074 9.5H22.4567L20.0789 2.17643H20.0047L17.6222 9.5ZM17.4878 5.76869H22.5679V7.33538H17.4878V5.76869Z"/>`,
            'asc': `<path d="M6 7.49967H12V6.16634H6V7.49967ZM6 4.83301H10.6667V3.49967H6V4.83301ZM6 10.1663H13.3333V8.83301H6V10.1663ZM6 2.16634H9.33333V0.833008H6V2.16634ZM2 0.166341H3.33333V8.16634H5.33333L2.66667 10.833L0 8.16634H2V0.166341Z"/>`,
            'dec': `<path d="M6 3.50033H12V4.83366H6V3.50033ZM6 6.16699H10.6667V7.50033H6V6.16699ZM6 0.833659H13.3333V2.16699H6V0.833659ZM6 8.83366H9.33333V10.167H6V8.83366ZM2 10.8337H3.33333V2.83366H5.33333L2.66667 0.166992L0 2.83366H2V10.8337Z"/>`
          };

          const activeFilter = ['az', 'za', 'asc', 'dec'].find(activeItem => activeListItem.classList.contains(activeItem));

          if (activeFilter) {
            svgElement.innerHTML = filterSvg[activeFilter];
          }
        }
      });
    });

    //sort filter js
    // Fixes setting default values.
    if (this.parentSelected) {
      this.set(this.parentSelected);
    }
  },

  methods: {
    /**
     * Handles toggling the dropdown visibility as triggers are used.
     *
     * @method toggleDropdown
     * @param {Object} event - Javascript event object
     * @public
     */
    toggleDropdown(e) {
      if (!this.isExpanded) {
        this.openDropdown();
      }
      else {
        this.closeDropdown();
      }
    },

    /**
     * Opens the dropdown by making the list visible.
     *
     * @method openDropdown
     * @public
     */
    openDropdown() {
      this.isExpanded = true;

      TweenLite.set(this.$refs.list, { height: 'auto' });

      if (this.willExtendBeyondViewport()) {
        this.$refs.list.classList.add(CLASSES.OPEN_ABOVE);
      }
      else {
        this.$refs.list.classList.remove(CLASSES.OPEN_ABOVE);
        TweenLite.from(this.$refs.list, 0.2, {
          height: 0,
          onComplete: () => {
            this.focusItem(this.selectedIndex);
          }
        });
      }

      document.body.addEventListener(Events.CLICK, e => this.handleOffClick(e));
      document.body.addEventListener(Events.KEYDOWN, e => this.handleBodyKeydown(e));
    },

    /**
     * Closes the dropdown by removing list visibility.
     *
     * @method closeDropdown
     * @public
     */
    closeDropdown() {
      this.isExpanded = false;

      document.body.removeEventListener(Events.CLICK, e => this.handleOffClick(e));
      document.body.removeEventListener(Events.KEYDOWN, e => this.handleBodyKeydown(e));
    },

    /**
     * Handles selection of an item from a click or keypress.
     *
     * @method selectItem
     * @param {Number} key - The key of the item to select
     * @public
     */
    selectItem(key) {
      const item = this.$refs[key];
      const link = item.querySelector('.dropdown-list-link');

      if (link) {
        link.click();
      }

      this.closeDropdown();
      this.selected = item.children[0].textContent;
      this.selectedIndex = key;
    },

    /**
     * Resets the element to the default value.
     *
     * Exists to be used by parent elements, such as filters.
     */
    reset() {
      this.selectItem(0);
    },

    /**
     * Set the element to a specific value.
     *
     * Exists to be used by parent elements, such as filters.
     *
     * @param {String} value
     *   The human readable value to set the element to.
     */
    set(value) {
      const selectedKey = $(this.$refs.list).find(`[data-value="${value}"]`).parent().index();
      if (selectedKey >= 0) {
        this.selectItem(selectedKey);
      }
    },

    /**
     * Closes an open dropdown when a click falls outside of it.
     *
     * @method handleOffClick
     * @param {Object} event - Javascript event object
     * @public
     */
    handleOffClick(e) {
      const target = e.target;
      if (this.$el !== target && !this.$el.contains(target)) {
        this.closeDropdown();
      }
    },

    /**
     * Closes an open dropdown if the escape key is used.
     *
     * @method handleBodyKeydown
     * @param {Object} event - Javascript event object
     * @public
     */
    handleBodyKeydown(e) {
      if (e.keyCode === KeyCodes.ESCAPE) {
        this.closeDropdown();
      }
    },

    /**
     * Handles keypresses on the dropdown toggle.
     *
     * @method handleToggleKeydown
     * @param {Object} event - Javascript event object
     * @public
     */
    handleToggleKeydown(e) {
      this.$refs[0].focus();
    },

    /**
     * Given a keycode, focuses the next relevant item.
     *
     * @method focusItem
     * @param {Number} currentIndex - The index of the currently selected item.
     * @public
     */
    focusItem(index) {
      const item = this.$refs[index];
      if (item) {
        item.focus();
      }
    },

    /**
     * Determines if the list height would extend beyond the visible viewport.
     *
     * @return {Boolean} - If the list will/won't extend beyond the viewport.
     */
    willExtendBeyondViewport() {
      // Avoids opening upwards in situations where an upward list would get cut
      // off by the container's overflow rules. This is only an acceptable
      // solution when there's significant content below the dropdown.
      if (this.$el.classList.contains(CLASSES.IGNORE_VIEWPORT)) {
        return false;
      }

      const $trigger = $(this.$refs.trigger);
      const triggerBottom = $trigger.offset().top + $trigger.outerHeight();
      const listHeight = parseInt($(this.$refs.list).css('max-height'), 10);
      const viewportBottom = $(window).scrollTop() + $(window).height();

      return triggerBottom + listHeight > viewportBottom && listHeight < $(window).height();
    }
  }
})
